
<script lang="ts" setup>
  import { computed, toRefs } from 'vue';

  import { themingCssClass } from "vue/applications/frontend/mixins/theming-mixin";

  const props = defineProps({
    scoreLevel: {
      type: Object,
      default: null,
    },
    currentValue: {
      type: Number,
      default: null,
    },
    active: {
      type: Boolean,
      default: false,
    },
    hiddenIfInactive: {
      type: Boolean,
      default: false,
    },
    light: {
      type: Boolean,
      default: false,
    },
    black: {
      type: Boolean,
      default: false,
    },
    tooltipPrefix: {
      type: String,
      default: "",
    },
  });

  defineEmits(["trigger"])

  const { scoreLevel, currentValue, active, light, black} = toRefs(props);

  const isActive = computed(() => active.value || scoreLevel.value.value === currentValue.value)
   
  const bubbleCssClasses = computed(() => {
    const result = [];

    result.push(themingCssClass("border"));

    if (isActive.value) {
      result.push("bubble-is-selected");
      result.push(themingCssClass("inverted"));
    } else {
      result.push("bubble-is-not-selected");
      result.push(themingCssClass("normal"));
    }

    if (light.value) {
      result.push("light");
    }

    if (black.value) {
      result.push("black");
    }

    result.push(scoreLevel.value.item_type);

    // [
    //   { active: active || scoreLevel.value == currentValue, light },
    //   scoreLevel.item_type,
    // ]

    return result;
  })
</script>

<template>
  <div class="components__score-item-bubble">
    <div
      v-bind:style="{
        visibility:
          hiddenIfInactive && !active && scoreLevel.value !== currentValue
            ? 'hidden'
            : 'initial',
      }"
      v-on:click="$emit('trigger')"
      v-if="scoreLevel"
      v-bind:class="bubbleCssClasses"
      v-bind:title="tooltipPrefix + scoreLevel.tooltip"
    >
      {{ scoreLevel.label }}
    </div>
  </div>
</template>

<style lang="scss" scoped>
@use "~stylesheets/frontend/variables/colors";

.components__score-item-bubble {
  > div {
    &.bubble-is-not-selected {
      background-color: colors.$color-white;
    }
    width: 30px;
    height: 30px;
    line-height: 30px;
    text-align: center;
    border-radius: 4px;
    font-size: 16px;
    user-select: none;

    &.light {
      background-color: colors.$color-white;
      $_light_color: colors.$color-black-very-light;
      $_light_color: colors.$color-black-border;
      border: 1px solid $_light_color;
      color: $_light_color;
      &.active {
        background-color: $_light_color;
      }
    }

    &.black {
      background-color: black;
      border: 1px solid white;
      color: white;
    }

    cursor: pointer;

    &.yes_no {
      font-size: 14px;
    }

    &.active {
      color: colors.$color-white;
      background-color: colors.$color-green;
    }

    &.hidden {
      visibility: hidden;
    }
  }
}
</style>
